<template>
  <div>
    <p class="cm-mg-p-wzd">1.1 {{ $t('config.user_info') }}</p>
    <hr />
    <div class="row">
      <div class="col-md-4">
        <fg-input
          type="text"
          :label="`${$t('common_words.names')} *`"
          v-model="model.first_name"
          name="common_words.names"
          v-validate="modelValidations.first_name"
          :error="getError('common_words.names', true)"
        >
        </fg-input>
      </div>
      <div class="col-md-4">
        <fg-input
          type="text"
          :label="`${$t('common_words.surnames')} *`"
          v-model="model.last_name"
          name="common_words.surnames"
          v-validate="modelValidations.last_name"
          :error="getError('common_words.surnames', true)"
        >
        </fg-input>
      </div>
      <div class="col-md-4">
        <fg-input
          type="text"
          :label="`${$t('common_words.document_number')}`"
          v-model="model.document_id"
        >
        </fg-input>
      </div>
      <div class="col-md-12">
        <fg-input
          type="email"
          :label="`${$t('common_words.email')} *`"
          placeholder="xxxx@gmail.com"
          v-model="model.email"
          name="common_words.email"
          v-validate="modelValidations.email"
          :error="getError('common_words.email', true)"
        ></fg-input>
      </div>
      <div class="col-md-6">
        <fg-input
          type="text"
          :label="`${$t('common_words.username')} *`"
          v-model="model.username"
          name="common_words.username"
          v-validate="modelValidations.username"
          :error="getError('common_words.username', true)"
        >
        </fg-input>
      </div>
      <div class="col-md-6">
        <fg-input
          type="text"
          :label="`${$t('common_words.nfc')}`"
          v-model="model.nfc_id"
        >
        </fg-input>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('common_words.companies2') }} *</label
          >
          <br />
          <el-select
            @change="
              selectAllFromSelect('model.businesses', businesses);
              handleBusinessesChange($event);
            "
            clearable
            multiple
            filterable
            class="select-primary custom-width-select required-businesses shadow-sm"
            size="large"
            v-model="model.businesses"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in businesses"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group has-label">
          <label class="text-transform-none">{{
            $t('common_words.farms2')
          }}</label>
          <el-checkbox
            class="ml-4"
            size="medium"
            v-model="model.only_filter_own_farms"
            >{{ $t('config.index_only_farm_selection') }}</el-checkbox
          >
          <br />
          <el-select
            @change="selectAllFromSelect('model.farms', filteredFarms)"
            clearable
            multiple
            filterable
            class="select-primary custom-width-select shadow-sm"
            size="large"
            v-model="model.farms"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in filteredFarms"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { mapActions } from 'vuex';
import { Checkbox } from 'element-ui';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import SweetAlert from 'src/class/Alerts';
import MixinForm from 'src/mixins/forms/mixin-form';

export default {
  components: {
    [Checkbox.name]: Checkbox,
  },

  data() {
    return {
      model: {
        first_name: null,
        last_name: null,
        document_id: null,
        email: null,
        username: null,
        nfc_id: null,
        businesses: [],
        farms: [],
        only_filter_own_farms: false,
      },
      modelValidations: {
        first_name: {
          required: true,
        },
        last_name: {
          required: true,
        },
        username: {
          required: true,
        },
        email: {
          required: true,
          email: true,
        },
      },
      businesses: null,
      farms: null,
      filteredFarms: [],
    };
  },

  mixins: [MixinPermissions, MixinForm, mixinMasters],

  watch: {
    '$i18n.locale': 'getSelectAll',
  },

  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    handleBusinessesChange($event) {
      const filtereds = [];
      this.filteredFarms = this.concatAll(
        this.farms.filter((farm) =>
          $event.some((business_id) =>
            farm.businesses.map((business) => business.id).includes(business_id)
          )
        )
      );

      const farmIds = [];
      this.filteredFarms.forEach((farm) => farmIds.push(farm.id));
      this.model.farms.forEach((id) => {
        if (Number(id) > 0 && farmIds.includes(id)) filtereds.push(id);
      });

      this.$set(this.model, 'farms', filtereds);
    },

    validate() {
      if (this.model.businesses.length == 0) {
        return this.validationInputsRequired('businesses');
      } else {
        return this.$validator.validateAll().then((res) => {
          this.$emit('on-validated', res, this.model);

          let others = [];
          this.businesses.forEach((item) => {
            this.model.businesses.forEach((element) => {
              if (element == item.id) {
                others.push(item.name);
              }
            });
          });

          let othersF = [];
          this.farms.forEach((item) => {
            this.model.farms.forEach((element) => {
              if (element == item.id) {
                othersF.push(item.name);
              }
            });
          });

          this.$emit('fillUserForm', 'firstStep', {
            names_businesses: others,
            names_farms: othersF,
          });
          return res;
        });
      }
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);

      Axios.getMasters('businesses/only')
        .then((response) => {
          this.businesses = this.concatAll(response.data.data);

          if (!sessionStorage.getItem('editForm')) {
            this.model.businesses = this.selectElementsAsignFromModel(
              1,
              this.model.businesses,
              this.businesses
            );

            if (this.model.businesses === null && this.businesses.length == 1) {
              this.model.businesses.push(this.businesses[0].id);
            }
          }

          Axios.getMasters('farms/farms/only')
            .then((response1) => {
              this.farms = response1.data.data;

              if (!sessionStorage.getItem('editForm')) {
                if (this.model.farms === null && this.farms.length == 1) {
                  this.model.farms.push(this.farms[0].id);
                }
              }

              this.handleBusinessesChange(this.model.businesses);
              this.showHideLoading();
            })
            .catch((error) => {
              this.showHideLoading();
              console.log(error);
              SweetAlert.warning(error.response.data.message);
            });
        })
        .catch((error) => {
          this.showHideLoading();
          console.log(error);
          SweetAlert.warning(error.response.data.message);
        });
    } else this.showHideLoading();
  },

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.first_name = editForm.first_name;
      this.model.last_name = editForm.last_name;
      this.model.document_id = editForm.document_id;
      this.model.email = editForm.email;
      this.model.username = editForm.username;
      this.model.nfc_id = editForm.nfc_id;
      this.model.only_filter_own_farms =
        editForm.only_filter_own_farms === 1 ? true : false;

      editForm.business.forEach((item) => {
        this.model.businesses.push(item.id);
      });

      editForm.farms.forEach((item) => {
        this.model.farms.push(item.id);
      });
    }
  },
};
</script>
<style></style>
